import {useEffect} from 'react';
import {useCountdown} from 'usehooks-ts';
import {FormattedMessage} from 'react-intl';

import {Button, BUTTON_VARIANT, BUTTON_SIZE} from '@time-webkit/all/atoms/button';

type Props = {
    className?: string;
    retryTimeoutSec?: number;
    onClick?: () => void;
    isDisabled?: boolean;
}

const DEFAULT_RETRY_TIMEOUT_SEC = 15;

export const RetryButton = ({onClick, className, retryTimeoutSec = DEFAULT_RETRY_TIMEOUT_SEC, isDisabled = false}: Props) => {
    const [count, {startCountdown}] = useCountdown({countStart: retryTimeoutSec});

    useEffect(() => {
        if (retryTimeoutSec > 0) {
            startCountdown();
        }
    }, [retryTimeoutSec]);

    const handleClick = () => {
        onClick?.();
    };

    const isTimerRunning = count > 0;

    return (
        <Button
            type='button'
            className={className}
            isDisabled={isTimerRunning || isDisabled}
            onPress={handleClick}
            variant={BUTTON_VARIANT.FLAT}
            size={BUTTON_SIZE.LARGE}
        >
            {(isTimerRunning && !isDisabled) ? (
                <FormattedMessage
                    id='signup.email_guest.confirm_phone_retry_button_disabled_text'
                    defaultMessage={'Repeat after {seconds} seconds'}
                    values={{seconds: count}}
                />
            ) : (
                <FormattedMessage
                    id='signup.email_guest.confirm_phone_retry_button_text'
                    defaultMessage={'Send again'}
                />
            )}
        </Button>
    );
};
